(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["complementary-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('complementary-products')) {
    class ComplementaryProducts extends HTMLElement {
      connectedCallback() {
        if (this.dataset.loaded === 'true') return;

        const loadRecommendations = () => {
          fetch(this.dataset.url)
            .then((response) => response.text())
            .then((text) => {
              const responseDocument = new DOMParser().parseFromString(text, 'text/html');
              const replacement = responseDocument.getElementById(this.id);

              if (replacement && replacement.innerHTML.trim().length > 0) {
                this.innerHTML = replacement.innerHTML;
                this.dataset.loaded = 'true';
              }
            })
            .catch(() => {});
        };

        if (!('IntersectionObserver' in window)) {
          loadRecommendations();
          return;
        }

        const observer = new IntersectionObserver(
          (entries) => {
            if (!entries[0].isIntersecting) return;
            observer.disconnect();
            loadRecommendations();
          },
          { rootMargin: '0px 0px 200px 0px' }
        );

        observer.observe(this);
      }
    }

    customElements.define('complementary-products', ComplementaryProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
